import { dashboardApiEndpoints } from "@dashboardApi/apis";
import type { DashboardApiEndpoints, DashboardApiEndpointDefinitions } from "@dashboardApi/apis";
import { createContext, useContext } from "react";

export const DashboardApiContext = createContext(dashboardApiEndpoints);

/**
 * A low-level hook for pulling an endpoint definition out of the endpoint defs. This is using context to
 * make it possible to fake endpoints in storybook.
 *
 * This should not be used in most cases. Instead, use `@services/useDashboardApiQuery` and `@services/useDashboardApiMutation`.
 * For private APIs, use the hooks returned from `@services/getPrivateApiHooks`
 * @param endpoint a key into the global API endpoint definitions.
 */
export const useDashboardApi = <Endpoint extends DashboardApiEndpoints>(
  endpoint: Endpoint
): DashboardApiEndpointDefinitions[Endpoint] => {
  const endpoints = useContext(DashboardApiContext);

  return endpoints[endpoint];
};
